const notification = require("@/assets/audios/internal-chat-notification.mp3");

export default {
  SET_INTERNAL_CHAT_MESSAGES(state, { userId, concatResults, items }) {
    if (concatResults && state.selectInternalChat.user_id === userId) {
      state.selectInternalChat.chats = [
        ...state.selectInternalChat.chats.map(existingItem => items.find(newItem => newItem.id === existingItem.id) || existingItem),
        ...items.filter(newItem => !state.selectInternalChat.chats.some(existingItem => existingItem.id === newItem.id))
      ]
    } else {
      state.selectInternalChat.chats = items
      state.selectInternalChat.user_id = userId
    }

    state.selectInternalChat.chats.sort((a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    )
  },
  REMOVE_TEMPORARILY_MESSAGE(state, tempMessageToRemove) {
    state.selectInternalChat.chats = state.selectInternalChat.chats.filter(chat => {
      return !(chat.is_temp && !chat.type && tempMessageToRemove.message === chat.message);
    });
  },
  SET_ACK_MESSAGE(state, internalChat) {
    const chatIndex = state.selectInternalChat.chats.findIndex(chat => chat.id === internalChat.id);
    if (chatIndex !== -1) { state.selectInternalChat.chats[chatIndex].ack = internalChat.ack; }
  },
  SET_REPLY_MESSAGE(state, replyinternalChatMessage) {
    state.replyinternalChatMessage = replyinternalChatMessage
  },
  SET_INTERNAL_CHAT_MESSAGE_INFOS(state, internalChatMessageInfos) {
      state.internalChatMessageInfos = internalChatMessageInfos
  },
  RESET_INTERNAL_CHAT_MESSAGES(state) {
    state.selectInternalChat = {
      user_id: null,
      chats: [],
    }
  },
  INTERNAL_CHAT_NOTIFICATION() {
    const notificationSound = new Audio(notification)
    notificationSound.play()
  },
  SOCKET_WAS_LISTENED(state) {
      state.isSocketAlreadyListened = true
  }
}